/**
 * Forget who the user was and ask again — what signing IN and signing OUT both need.
 *
 * Measured in the browser 2026-09-24: `queryClient.clear()` empties the cache but the gate's
 * `auth.get_current_user` observer keeps rendering its last answer (the query is
 * `staleTime: Infinity`, and a cleared query has no observer left to refetch), so a sign-in left
 * the login page up and a sign-out left the app up. A RESET does both halves: the previous
 * user's answers are dropped and everything mounted is asked again.
 */
import type { QueryClient } from '@tanstack/react-query'

export async function refreshIdentity(queryClient: QueryClient): Promise<void> {
  try {
    // `resetQueries`, NOT `clear`: clearing removes the queries, leaving the gate's own observer
    // with nothing to refetch and its last answer still on screen. Reset drops the data and
    // re-runs everything mounted — the identity query included, which is the whole point.
    await queryClient.resetQueries()
  } catch {
    // The gate reads the query's own state; a rejection here means "signed out", which is fine.
  }
}
